export default "/images/back_arrow.svg"